export default function ({ route, redirect, store, app }) {
  const paywall = route.query.paywall;
  if (paywall === 'active') {
    store.commit('paywallStore/setView', 'active'); 
  }
}
